"use client";

import React from "react";
import { Handshake, GraduationCap, TrendingUp, BriefcaseBusiness } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const valueProps = [{
  title: "Mentorship",
  description: "Work with experienced people who can help you understand the client context, build confidence, and develop sound professional judgment.",
  icon: Handshake
}, {
  title: "Professional Development",
  description: "Build practical skills through client work, internal learning, reporting tools, systems development, and focused training where it supports your role.",
  icon: GraduationCap
}, {
  title: "Leadership Pathways",
  description: "Take ownership of meaningful work over time, with opportunities to lead files, improve processes, support clients, and help shape how work is delivered.",
  icon: TrendingUp
}, {
  title: "Practical Client Work",
  description: "Learn by doing work that matters, including financial management, reporting, funding support, audit readiness, planning, and client systems.",
  icon: BriefcaseBusiness
}];
export default function ValuePropsGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257371" id="growth-ownership-and-development" className="bg-slate-50 text-foreground py-16 md:py-24 border-b border-border/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <div className="h-1 w-12 bg-secondary-500 mx-auto mb-6 rounded-full" />

          <p className="text-secondary-700 font-semibold tracking-[0.18em] text-xs uppercase mb-4 font-default">
            Your Career at RiverBend
          </p>

          <h2 className="text-primary-600 text-3xl md:text-4xl lg:text-5xl font-bold mb-5 font-default leading-tight tracking-tight">
            Growth, ownership, and development.
          </h2>

          <p className="text-muted-foreground text-lg md:text-xl font-default leading-relaxed">
            RiverBend is a small, growing firm. That creates room for people to
            learn, take responsibility, contribute ideas, and build practical
            skills through real client work.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {valueProps.map((item, i) => <Card key={i} data-index={i} className="bg-white border border-border/70 rounded-2xl shadow-sm hover:shadow-md transition-shadow h-full">
              <CardHeader className="p-6 pb-4">
                <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mb-5">
                  <item.icon className="w-6 h-6 text-secondary-700" />
                </div>

                <CardTitle className="text-primary-600 text-xl font-default leading-snug">
                  {item.title}
                </CardTitle>
              </CardHeader>

              <CardContent className="px-6 pb-6 pt-0">
                <p className="text-muted-foreground leading-relaxed font-default text-sm md:text-base">
                  {item.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}